import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 购物车数量
export function getenquirysj(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/enquiry/getEnquiryOfferNum',
    method: 'get',
    params
  })
}
// 轮播图
export function getBanner(params) {
  return axios.request({
    url: urlObj.wss + 'wss-system/banner/gateway/getBanner',
    method: 'get',
    params
  })
}

// 纵向导航
// export function getlistAllGroup(params) {
//   return axios.request({
//     url: urlObj.wss + 'wss-part/parts/gateway/listAllGroup',
//     method: 'get',
//     params
//   })
// }
// 配件的导航数据
export function getlistAllGroup(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/gateway/groups',
    method: 'get',
    params
  })
}

// 侧边栏的数据
export function getpartsdhdata(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/home/gateway/section',
    method: 'get',
    params
  })
}

// 购物车数量
export function getCount(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/shopping/getCount',
    method: 'get',
    params
  })
}

// 新品列表9 个
export function getNewProductList(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/wssHomePage/gateway/getNewProductList',
    method: 'get',
    params
  })
}

// 热销配件（平台）
export function getSalesVolume(data) {
  return axios.request({
    url: urlObj.wss + `wss-order/order/gateway/getSalesVolume?num=${data}`,
    method: 'get'
  })
}
// 电子目录（平台）
export function getErp(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/mingjue/gateway/access/plugin',
    method: 'get',
    params
  })
}

// 切换店铺
export function getTenant(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/authority/switch/tenant',
    method: 'get',
    params
  })
}

export function saveFeedBackInfo(data) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/authority/saveFeedBackInfo',
    method: 'post',
    data
  })
}
